import React from "react";
import { Modal } from "react-bootstrap";
import { FiX } from "react-icons/fi";

function Exco1({ show, onClose, onOpen }) {
  return (
    <div>
      <div>
        <Modal
          size="lg"
          show={show}
          onHide={onClose}
          // backdrop="static"
          aria-labelledby="example-modal-sizes-title-lg"
          keyboard={false}
          animation={true}
          centered
        >
          <Modal.Body>
            <div className="Solera__Cont">
              <FiX className="Solera__Close" onClick={onClose} />
            </div>

            <div className="Exoc-Name">Mayowa Oluyede</div>
            <div className="Exco-Tittle">Walfare Officer</div>
            <br />

            <div className="Excos-Bio">
              MAYOWA OLUYEDE holds a Bsc degree in Estate Management from the
              University of Lagos in 1991 and a postgraduate in Real Estate
              Development from Westminster University in the UK. . <br /> <br />
              Mayowa is a successful entrepreneur in the United Kingdom, who has
              built a successful career in the real estate and property
              investment sector.He is the founder and CEO of MS Estates, an
              Estate Agency firm based in Dagenham and Grays both in Essex.{" "}
              <br /> <br />
              With over three decades of experience in Real Estate investing,
              Mayowa shares valuable lessons from his ongoing journey as an
              entrepreneur in his weekly vlog. He also host webinars and monthly
              seminars where he doles out answers to questions about property
              investment, trading the capital market, successful living and
              entrepreneurship based on a lifetime of building a multi-million
              pound property investment portfolio.
              <br /> <br />
              Mayowa is a proud member of the Unilag Alumni UK since 2017 . He
              has actively contributed to the association's growth and success.
              He currently serves as the welfare officer of the association and
              believes that relationships and collaborations is essential for us
              to build a great association.<br /> <br />Mayowa is an international speaker, wealth and certified high performance coach .
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </div>
  );
}

export default Exco1;
